import { FAMILY_NAME_GIVEN_NAME_ORDERING_INDEXED_BY_LANGUAGE } from './constants.mjs';
import { languageFromLocale } from './utilities/languageFromLocale.mjs';

function hasFamilyNameGivenNameOrdering(locale) {
  const familyNameGivenNameOrdering = FAMILY_NAME_GIVEN_NAME_ORDERING_INDEXED_BY_LANGUAGE.get(languageFromLocale(locale));
  return Boolean(familyNameGivenNameOrdering);
}

export { hasFamilyNameGivenNameOrdering };
